import React, { FC, memo } from 'react'

import { DiscountCodeTypes, ShopAppliedDiscountCode } from 'Types'

interface TooltipOverlayProps {
  code: ShopAppliedDiscountCode
}

const TooltipOverlay: FC<TooltipOverlayProps> = ({ code }) => {
  return code.discountType === DiscountCodeTypes.AMOUNT ? (
    <div className="text-left">
      <div>
        <b>Fixed amount:</b> {code.discountMoneyFormatted}
      </div>
      {code.limitForUser ? (
        <div>
          <b>Limit for user:</b> {code.limitForUser}
        </div>
      ) : null}
    </div>
  ) : (
    <div className="text-left">
      <div>
        <b>Percentage:</b> {code.percent} <b>%</b>
      </div>
      {code.maxDiscountMoneyFormatted ? (
        <div>
          <b>Maximum discount:</b> {code.maxDiscountMoneyFormatted}
        </div>
      ) : null}
      {code.minOrderMoney > 0 ? (
        <div>
          <b>Minimum order size:</b> {code.minOrderMoneyFormatted}
        </div>
      ) : null}
      {code.limitForUser ? (
        <div>
          <b>Limit for user:</b> {code.limitForUser}
        </div>
      ) : null}
    </div>
  )
}

export default memo(TooltipOverlay)
